import { render, staticRenderFns } from "./ManufacturerListAddNew.vue?vue&type=template&id=3450bf84&"
import script from "./ManufacturerListAddNew.vue?vue&type=script&lang=js&"
export * from "./ManufacturerListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports